export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_O365_USER as string,
    redirectUri:
      process.env.REACT_APP_MICROSOFT_LOGIN_REDIRECT ||
      process.env.REACT_APP_O365_REDIRECT,
  },
  scopes: ["User.Read"],
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const microsoftSignupRequest = {
  prompt: "select_account",
  scopes: ["openid", "email", "profile", "User.Read"],
};
